import {defineStore} from 'pinia';
import {useConsignments} from 'dummen-shared/composables/useConsignments.ts';

export const useConsignmentStore = defineStore('consignmentStore', () => {
	const composable = useConsignments();
	composable.initConsignments();

	return composable;
});
